(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvati-dosage-modal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const MODAL_SELECTOR = '[data-tvati-dosage-modal]';
  const TRIGGER_SELECTOR = 'a[href="#dosage"], [data-tvati-dosage-trigger], [data-tvati-open-dosage]';
  const STORAGE_PREFIX = 'tvati:product-selection:';

  const numberLabel = (value) => {
    const rounded = Math.round(Number(value) * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  };

  const frequencyWords = (value) => {
    const numeric = Number(value);

    if (Math.abs(numeric - 1) < 0.001) return 'once';
    if (Math.abs(numeric - 2) < 0.001) return 'twice';
    if (Math.abs(numeric - 3) < 0.001) return 'three times';
    if (Math.abs(numeric - 4) < 0.001) return 'four times';
    if (Math.abs(numeric - 5) < 0.001) return 'five times';
    if (Math.abs(numeric - 6) < 0.001) return 'six times';

    return `${numberLabel(numeric)} times`;
  };

  const getFrequencyText = (minRate, maxRate) => {
    const min = Number(minRate) || 0;
    const max = Number(maxRate) || min;

    if (!min || !max) return '';

    if (Math.abs(min - max) < 0.001) {
      if (Math.abs(min - 7) < 0.001) return 'daily';
      return `${frequencyWords(min)} per week`;
    }

    return `${numberLabel(Math.min(min, max))}–${numberLabel(Math.max(min, max))} times per week`;
  };

  const getStartingCopy = (minRate, maxRate, isSingleVariantProduct = false) => {
    const frequency = getFrequencyText(minRate, maxRate);

    if (!frequency) {
      return isSingleVariantProduct
        ? 'See the recommended starting routine for this product.'
        : 'Select your pet size to see the recommended starting routine.';
    }

    if (frequency === 'daily') {
      return 'Apply one full vial daily, keeping the routine as consistent as possible.';
    }

    return `Apply one full vial ${frequency}, spacing applications evenly where possible.`;
  };

  const formatDuration = (vialCount, minRate, maxRate) => {
    const vials = Number(vialCount) || 0;
    const min = Math.min(Number(minRate) || 0, Number(maxRate) || Number(minRate) || 0);
    const max = Math.max(Number(minRate) || 0, Number(maxRate) || Number(minRate) || 0);

    if (!vials || !min || !max) return '';

    const shortestWeeks = vials / max;
    const longestWeeks = vials / min;
    const shortestDays = Math.round(shortestWeeks * 7);
    const longestDays = Math.round(longestWeeks * 7);
    const isFixedRoutine = Math.abs(shortestWeeks - longestWeeks) < 0.05;

    /*
     * Keep short / awkward decimal durations human-readable.
     * Examples:
     * - 12 vials at 1/day  -> up to 12 days
     * - 30 vials at 1/day  -> up to 30 days
     * - 28 days exactly    -> up to 4 weeks
     *
     * Longer ranges stay in weeks because "4–6 weeks" and "7.5–10 weeks"
     * read much better than large day ranges.
     */
    if (isFixedRoutine) {
      const nearestWholeWeek = Math.round(longestWeeks);
      const isCleanWholeWeek =
        longestWeeks >= 2 &&
        Math.abs(longestWeeks - nearestWholeWeek) < 0.05;

      if (isCleanWholeWeek) {
        return `up to ${nearestWholeWeek} ${nearestWholeWeek === 1 ? 'week' : 'weeks'}`;
      }

      if (longestDays <= 56) {
        return `up to ${longestDays} ${longestDays === 1 ? 'day' : 'days'}`;
      }

      const roundedHalfWeeks = Math.round(longestWeeks * 2) / 2;
      return `approximately ${numberLabel(roundedHalfWeeks)} weeks`;
    }

    if (longestWeeks < 2.25) {
      return `approximately ${shortestDays}–${longestDays} days`;
    }

    return `approximately ${numberLabel(shortestWeeks)}–${numberLabel(longestWeeks)} weeks`;
  };

  const buildPackCopy = (modal, minRate, maxRate, selectedVariantId = '') => {
    const node = modal.querySelector('[data-tvati-dosage-packs]');
    const output = modal.querySelector('[data-tvati-dosage-pack-copy]');
    if (!node || !output) return;

    let packs = [];

    try {
      packs = JSON.parse(node.textContent || '[]');
    } catch (error) {
      packs = [];
    }

    packs = packs
      .map((pack) => ({
        ...pack,
        id: String(pack.id || ''),
        vialCount: Number(pack.vialCount) || 0
      }))
      .filter((pack) => pack.vialCount > 0)
      .sort((a, b) => a.vialCount - b.vialCount);

    if (!packs.length || !minRate || !maxRate) {
      output.textContent = '';
      output.hidden = true;
      return;
    }

    const durations = packs
      .map((pack) => ({
        ...pack,
        duration: formatDuration(pack.vialCount, minRate, maxRate)
      }))
      .filter((pack) => pack.duration);

    if (!durations.length) {
      output.textContent = '';
      output.hidden = true;
      return;
    }

    const selectedId = String(selectedVariantId || '');
    const selectedPack = durations.find((pack) => pack.id === selectedId) || null;

    const orderedPacks = selectedPack
      ? [selectedPack, ...durations.filter((pack) => pack.id !== selectedPack.id)]
      : durations;

    if (orderedPacks.length === 1) {
      const pack = orderedPacks[0];
      output.textContent =
        `At this starting routine, the ${pack.vialCount}-vial pack will last ${pack.duration}.`;
      output.hidden = false;
      return;
    }

    const [first, ...rest] = orderedPacks;
    const firstSentence =
      `At this starting routine, the ${first.vialCount}-vial pack will last ${first.duration}.`;

    const comparisonParts = rest.map(
      (pack) => `the ${pack.vialCount}-vial pack will last ${pack.duration}`
    );

    let comparisonSentence = '';

    if (comparisonParts.length === 1) {
      comparisonSentence = ` The other option, ${comparisonParts[0]}.`;
    } else if (comparisonParts.length > 1) {
      comparisonSentence =
        ` The other options are ${comparisonParts.slice(0, -1).join(', ')} ` +
        `and ${comparisonParts.at(-1)}.`;
    }

    output.textContent = firstSentence + comparisonSentence;
    output.hidden = false;
  };

  const getCalendarIndexes = (minRate, maxRate) => {
    const min = Number(minRate) || 0;
    const max = Number(maxRate) || min;

    if (!min || !max) return [];

    const rate = Math.max(1, Math.min(7, Math.round(max)));

    const patterns = {
      1: [3],
      2: [1, 4],
      3: [1, 3, 5],
      4: [0, 2, 4, 6],
      5: [0, 1, 3, 4, 6],
      6: [0, 1, 2, 4, 5, 6],
      7: [0, 1, 2, 3, 4, 5, 6]
    };

    return patterns[rate] || [];
  };

  const readStoredSelection = (modal) => {
    const productId = modal.dataset.productId || '';

    try {
      return JSON.parse(
        sessionStorage.getItem(`${STORAGE_PREFIX}${productId}`) || '{}'
      );
    } catch (error) {
      return {};
    }
  };

  const getSelection = (modal) => {
    const apiSelection = window.TvatiProductSelectionAPI?.get?.();

    if (
      apiSelection &&
      String(apiSelection.productId || '') === String(modal.dataset.productId || '')
    ) {
      return apiSelection;
    }

    if (
      window.TvatiProductSelection &&
      String(window.TvatiProductSelection.productId || '') === String(modal.dataset.productId || '')
    ) {
      return window.TvatiProductSelection;
    }

    return readStoredSelection(modal);
  };

  const updateSizeCards = (modal, sizeIndex) => {
    const buttons = [...modal.querySelectorAll('[data-tvati-dosage-size]')];
    const index = Number.isFinite(Number(sizeIndex)) ? Number(sizeIndex) : 0;

    buttons.forEach((button) => {
      const active = Number(button.dataset.sizeIndex) === index;

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    return buttons.find((button) => Number(button.dataset.sizeIndex) === index) || buttons[0] || null;
  };

  const updateMaintenance = (modal, sizeIndex) => {
    modal.querySelectorAll('[data-maintenance-size]').forEach((node) => {
      node.hidden = Number(node.dataset.maintenanceSize) !== Number(sizeIndex);
    });
  };

  const updateCalendar = (modal, minRate, maxRate) => {
    const activeIndexes = new Set(getCalendarIndexes(minRate, maxRate));

    modal.querySelectorAll('[data-tvati-calendar-day]').forEach((day) => {
      const active = activeIndexes.has(Number(day.dataset.tvatiCalendarDay));
      day.classList.toggle('is-active', active);
    });
  };

  const syncModal = (modal, selection = null) => {
    if (!modal) return;

    const current = selection || getSelection(modal) || {};
    let sizeIndex = Number.isFinite(Number(current.sizeIndex))
      ? Number(current.sizeIndex)
      : 0;

    const selectedCard = updateSizeCards(modal, sizeIndex);
    if (!selectedCard) return;

    sizeIndex = Number(selectedCard.dataset.sizeIndex) || 0;

    const minRate =
      Number(current.minVialsPerWeek) ||
      Number(selectedCard.dataset.minVialsWeek) ||
      0;

    const maxRate =
      Number(current.maxVialsPerWeek) ||
      Number(selectedCard.dataset.maxVialsWeek) ||
      minRate;

    const startingCopy = modal.querySelector('[data-tvati-dosage-starting-copy]');

    if (startingCopy) {
      startingCopy.textContent = getStartingCopy(
        minRate,
        maxRate,
        modal.dataset.singleVariantProduct === 'true'
      );
    }

    updateCalendar(modal, minRate, maxRate);
    updateMaintenance(modal, sizeIndex);
    buildPackCopy(
      modal,
      minRate,
      maxRate,
      current.variantId || ''
    );
  };

  const setActiveTab = (modal, tabName) => {
    modal.querySelectorAll('[data-tvati-dosage-tab]').forEach((button) => {
      const active = button.dataset.tvatiDosageTab === tabName;

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
    });

    modal.querySelectorAll('[data-tvati-dosage-panel]').forEach((panel) => {
      const active = panel.dataset.tvatiDosagePanel === tabName;

      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  };

  const closeModal = (modal) => {
    if (!modal?.open) return;

    modal.close();

    if (window.location.hash === '#dosage') {
      history.replaceState(
        null,
        '',
        `${window.location.pathname}${window.location.search}`
      );
    }
  };

  const openModal = (modal) => {
    if (!modal) return;

    syncModal(modal);
    setActiveTab(modal, 'dosage');

    if (!modal.open) {
      modal.showModal();
    }

    document.documentElement.classList.add('tvati-dosage-modal-open');

    if (window.location.hash !== '#dosage') {
      history.replaceState(
        null,
        '',
        `${window.location.pathname}${window.location.search}#dosage`
      );
    }

    requestAnimationFrame(() => {
      modal.querySelector('[data-tvati-dosage-close]')?.focus({
        preventScroll: true
      });
    });
  };

  const initModal = (modal) => {
    if (!modal || modal.dataset.tvatiDosageReady === 'true') return;
    modal.dataset.tvatiDosageReady = 'true';

    modal.addEventListener('close', () => {
      document.documentElement.classList.remove('tvati-dosage-modal-open');
    });

    modal.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal(modal);
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal(modal);
        return;
      }

      const close = event.target.closest('[data-tvati-dosage-close]');
      if (close) {
        closeModal(modal);
        return;
      }

      const tab = event.target.closest('[data-tvati-dosage-tab]');
      if (tab) {
        setActiveTab(modal, tab.dataset.tvatiDosageTab);
        return;
      }

      const sizeButton = event.target.closest('[data-tvati-dosage-size]');
      if (!sizeButton) return;

      const sizeIndex = Number(sizeButton.dataset.sizeIndex) || 0;

      const mainSizeButton = document.querySelector(
        `[data-tvati-product-main] [data-tvati-size-option][data-size-index="${sizeIndex}"]`
      );

      if (mainSizeButton) {
        mainSizeButton.click();
      } else {
        syncModal(modal, {
          sizeIndex,
          minVialsPerWeek: Number(sizeButton.dataset.minVialsWeek) || 0,
          maxVialsPerWeek:
            Number(sizeButton.dataset.maxVialsWeek) ||
            Number(sizeButton.dataset.minVialsWeek) ||
            0
        });
      }
    });

    const tabs = [...modal.querySelectorAll('[data-tvati-dosage-tab]')];

    tabs.forEach((button, index) => {
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        event.preventDefault();

        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        const next = tabs[nextIndex];
        setActiveTab(modal, next.dataset.tvatiDosageTab);
        next.focus();
      });
    });

    syncModal(modal);
  };

  const initAll = () => {
    document.querySelectorAll(MODAL_SELECTOR).forEach(initModal);
  };

  initAll();

  if (!window.__tvatiDosageModalGlobalReady) {
    window.__tvatiDosageModalGlobalReady = true;

    /*
     * Capture phase is intentional:
     * tvati-product-main currently has its own direct dosage button handler.
     * We intercept it before that old handler so no product-tab scrolling fires.
     */
    document.addEventListener(
      'click',
      (event) => {
        const trigger = event.target.closest(TRIGGER_SELECTOR);
        if (!trigger) return;

        const modal = document.querySelector(MODAL_SELECTOR);
        if (!modal) return;

        event.preventDefault();
        event.stopPropagation();

        initModal(modal);
        openModal(modal);
      },
      true
    );

    document.addEventListener('tvati:product-selection-change', (event) => {
      document.querySelectorAll(MODAL_SELECTOR).forEach((modal) => {
        if (
          event.detail?.productId &&
          String(event.detail.productId) !== String(modal.dataset.productId || '')
        ) {
          return;
        }

        syncModal(modal, event.detail || null);
      });
    });

    window.addEventListener('hashchange', () => {
      const modal = document.querySelector(MODAL_SELECTOR);
      if (!modal) return;

      if (window.location.hash === '#dosage') {
        initModal(modal);
        openModal(modal);
      } else if (modal.open) {
        modal.close();
      }
    });

    document.addEventListener('shopify:section:load', () => {
      initAll();
    });
  }

  if (window.location.hash === '#dosage') {
    requestAnimationFrame(() => {
      const modal = document.querySelector(MODAL_SELECTOR);
      if (!modal) return;

      initModal(modal);
      openModal(modal);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvati-product-main"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initProductMain = (section) => {
    if (!section || section.dataset.tvatiProductReady === 'true') return;
    section.dataset.tvatiProductReady = 'true';

    const tabs = section.querySelector('[data-tvati-product-tabs]');
    const marketCountry = String(section.dataset.tvatiMarketCountry || '').toUpperCase();

    const localizeProductTabWeights = () => {
      if (!tabs || marketCountry !== 'US') return;

      const dataNode = section.querySelector('[data-tvati-product-weight-ranges]');
      if (!dataNode) return;

      let ranges = [];

      try {
        ranges = JSON.parse(dataNode.textContent || '[]');
      } catch (error) {
        ranges = [];
      }

      ranges = ranges.filter((item) => item && item.metric && item.us);
      if (!ranges.length) return;

      const escapeRegExp = (value) =>
        String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      const buildFlexibleRangeRegex = (metric) => {
        let pattern = escapeRegExp(String(metric).trim());
        pattern = pattern.replace(/\s+/g, '\\s*');
        pattern = pattern.replace(/[–—-]/g, '[-–—]');
        pattern = pattern.replace(/kg/gi, '\\s*kg');
        return new RegExp(pattern, 'gi');
      };

      const replacements = [];

      ranges.forEach((item) => {
        const label = String(item.label || '').toLowerCase();
        const usRange = String(item.us || '').trim();

        replacements.push({
          regex: buildFlexibleRangeRegex(item.metric),
          replacement: usRange
        });

        if (label.includes('large')) {
          replacements.push({
            regex: /31\s*kg\s*(?:and|&)\s*above/gi,
            replacement: usRange
          });
        }
      });

      const walker = document.createTreeWalker(
        tabs,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            const parent = node.parentElement;
            if (!parent) return NodeFilter.FILTER_REJECT;
            if (parent.closest('script, style, noscript')) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      const textNodes = [];
      let currentNode;

      while ((currentNode = walker.nextNode())) {
        textNodes.push(currentNode);
      }

      textNodes.forEach((textNode) => {
        let value = String(textNode.nodeValue || '');

        replacements.forEach(({ regex, replacement }) => {
          value = value.replace(regex, replacement);
        });

        if (value !== textNode.nodeValue) {
          textNode.nodeValue = value;
        }
      });
    };

    localizeProductTabWeights();

    const activateTab = (button, moveFocus = false) => {
      if (!tabs || !button) return;

      const buttons = [...tabs.querySelectorAll('[data-tvati-tab-button]')];
      const panels = [...tabs.querySelectorAll('[data-tvati-tab-panel]')];
      const panelId = button.getAttribute('aria-controls');

      buttons.forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-selected', active ? 'true' : 'false');
        candidate.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        const active = panel.id === panelId;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      if (moveFocus) button.focus();
    };

    if (tabs) {
      const buttons = [...tabs.querySelectorAll('[data-tvati-tab-button]')];

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activateTab(button));

        button.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;

          if (nextIndex === null) return;

          event.preventDefault();
          activateTab(buttons[nextIndex], true);
        });
      });
    }

    const purchase = section.querySelector('[data-tvati-purchase]');
    if (!purchase) return;

    const isSingleVariantProduct =
      purchase.dataset.singleVariantProduct === 'true';

    const isWholesaleCustomer =
      section.dataset.tvatiWholesaleCustomer === 'true';

    const wholesaleReferralNotice =
      purchase.querySelector('[data-tvati-wholesale-referral]');

    if (wholesaleReferralNotice && !isWholesaleCustomer) {
      let cameFromWholesaleCollection = false;

      try {
        if (document.referrer) {
          const referrerUrl = new URL(document.referrer);
          const referrerPath = referrerUrl.pathname.replace(/\/+$/, '');

          cameFromWholesaleCollection =
            referrerUrl.origin === window.location.origin &&
            referrerPath.endsWith('/collections/wholesale');
        }
      } catch (error) {}

      wholesaleReferralNotice.hidden = !cameFromWholesaleCollection;
    }

    const sizeButtons = [...purchase.querySelectorAll('[data-tvati-size-option]')];
    const packButtons = [...purchase.querySelectorAll('[data-tvati-pack-option]')];

    const selectedTitle = purchase.querySelector('[data-tvati-selected-title]');
    const selectedPrice = purchase.querySelector('[data-tvati-selected-price]');
    const savingText = purchase.querySelector('[data-tvati-subscription-saving]');

    const wholesaleRetailPrice = purchase.querySelector('[data-tvati-wholesale-retail-price]');
    const wholesaleResolvedPrice = purchase.querySelector('[data-tvati-wholesale-resolved-price]');
    const stickyWholesaleRetailPrice = section.querySelector('[data-tvati-sticky-wholesale-retail-price]');
    const stickyWholesaleResolvedPrice = section.querySelector('[data-tvati-sticky-wholesale-resolved-price]');
    const wholesaleBssProbe = purchase.querySelector('[data-tvati-product-bss-price-probe]');

    const usageHeading = purchase.querySelector('[data-tvati-usage-heading]');
    const durationText = purchase.querySelector('[data-tvati-duration]');
    const usageBody = purchase.querySelector('[data-tvati-usage-body]');
    const dailyCost = purchase.querySelector('[data-tvati-daily-cost]');

    const dosageTrigger = purchase.querySelector('[data-tvati-dosage-trigger]');
    const nativePurchase = purchase.querySelector('[data-tvati-native-purchase]');
    const variantDataNode = purchase.querySelector('[data-tvati-variant-data]');

    const stickyAtc = section.querySelector('[data-tvati-sticky-atc]');
    const stickyAtcButton = stickyAtc?.querySelector('[data-tvati-sticky-atc-button]');
    const stickyAtcLabel = stickyAtc?.querySelector('[data-tvati-sticky-atc-label]');
    const stickyAtcPack = stickyAtc?.querySelector('[data-tvati-sticky-atc-pack]');
    const stickyAtcMode = stickyAtc?.querySelector('[data-tvati-sticky-atc-mode]');
    const stickyAtcPrice = stickyAtc?.querySelector('[data-tvati-sticky-atc-price]');

    const productId = String(purchase.dataset.productId || '');

    /*
     * One-shot Get Started handoff.
     *
     * Generic historical selector state is NOT restored. The only persisted
     * state allowed to affect the initial size is a fresh explicit choice made
     * in the Get Started modal immediately before navigating to this PDP.
     */
    const getStartedHandoffKey = `tvati:get-started:selection:${productId}`;
    let getStartedHandoff = null;

    try {
      const storedHandoff = JSON.parse(
        sessionStorage.getItem(getStartedHandoffKey) || 'null'
      );

      /* Consume immediately so later direct visits cannot inherit it. */
      sessionStorage.removeItem(getStartedHandoffKey);

      const handoffAge =
        storedHandoff?.createdAt
          ? Date.now() - Number(storedHandoff.createdAt)
          : Number.POSITIVE_INFINITY;

      const incomingVariantId = String(
        purchase.dataset.initialVariantId || ''
      );

      const handoffVariantId = String(storedHandoff?.variantId || '');

      const isFreshHandoff =
        storedHandoff?.pendingDestination === true &&
        String(storedHandoff?.productId || '') === productId &&
        Number.isInteger(Number(storedHandoff?.sizeIndex)) &&
        Number(storedHandoff?.sizeIndex) >= 0 &&
        handoffAge >= 0 &&
        handoffAge <= 120000 &&
        (
          !handoffVariantId ||
          !incomingVariantId ||
          handoffVariantId === incomingVariantId
        );

      if (isFreshHandoff) {
        getStartedHandoff = storedHandoff;
      }
    } catch (error) {
      try {
        sessionStorage.removeItem(getStartedHandoffKey);
      } catch (storageError) {}
    }

    let variantData = {};

    try {
      variantData = JSON.parse(variantDataNode?.textContent || '{}');
    } catch (error) {
      variantData = {};
    }

    const currency = purchase.dataset.currency || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    const moneyFormatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const numberLabel = (value) => {
      const rounded = Math.round(value * 10) / 10;
      return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
    };

    const percentLabel = (value) => {
      const rounded = Math.round(value * 10) / 10;
      return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
    };

    /*
     * Page-lifetime selection state.
     *
     * Generic historical selector state is never restored. The only exception
     * is the validated one-shot Get Started handoff above.
     *
     * Otherwise the server-rendered product/variant is the source of truth for
     * a fresh product-page visit.
     */
    const state = {
      productId,
      sizeIndex: 0,
      sizeLabel: '',
      sizeRange: '',
      minVialsPerWeek: 0,
      maxVialsPerWeek: 0,

      variantId: String(purchase.dataset.initialVariantId || ''),
      vialCount: 0,

      sellingPlanId: '',
      purchaseMode: 'one-time',

      breed: ''
    };

    let lastPublishedState = '';

    const publishState = () => {
      const payload = {
        productId: state.productId,
        sizeIndex: state.sizeIndex,
        sizeLabel: state.sizeLabel,
        sizeRange: state.sizeRange,
        minVialsPerWeek: state.minVialsPerWeek,
        maxVialsPerWeek: state.maxVialsPerWeek,
        variantId: state.variantId,
        vialCount: state.vialCount,
        sellingPlanId: state.sellingPlanId,
        purchaseMode: state.purchaseMode,
        breed: state.breed
      };

      const serialized = JSON.stringify(payload);

      window.TvatiProductSelection = payload;
      window.TvatiProductSelections = window.TvatiProductSelections || {};
      window.TvatiProductSelections[productId] = payload;

      purchase.dataset.selectedSizeIndex = String(payload.sizeIndex ?? '');
      purchase.dataset.selectedSize = payload.sizeLabel || '';
      purchase.dataset.selectedSizeRange = payload.sizeRange || '';
      purchase.dataset.selectedVariantId = payload.variantId || '';
      purchase.dataset.selectedVialCount = String(payload.vialCount || '');

      if (serialized === lastPublishedState) return;
      lastPublishedState = serialized;

      document.dispatchEvent(
        new CustomEvent('tvati:product-selection-change', {
          detail: payload
        })
      );
    };

    window.TvatiProductSelectionAPI = {
      get() {
        return { ...window.TvatiProductSelection };
      },

      setBreed(value) {
        state.breed = String(value || '').trim();
        publishState();
      }
    };

    document.addEventListener('tvati:breed-change', (event) => {
      state.breed = String(event.detail?.breed || '').trim();
      publishState();
    });

    const getSizeButtonByIndex = (index) =>
      sizeButtons.find((button) => Number(button.dataset.sizeIndex) === Number(index)) || null;

    const getActivePackButton = () =>
      packButtons.find((button) => button.classList.contains('is-active')) || packButtons[0] || null;

    const getNativeVariantInput = (variantId) =>
      purchase.querySelector(`variant-picker input[data-variant-id="${variantId}"]`);

    const parseFirstNumber = (...values) => {
      for (const value of values) {
        if (value === null || value === undefined || value === '') continue;

        const match = String(value).match(/\d+(?:\.\d+)?/);
        if (!match) continue;

        const number = Number(match[0]);
        if (number > 0) return number;
      }

      return 0;
    };

    const resolveVialCount = (variantId, packButton = null) => {
      const variant = variantData[String(variantId)] || {};

      const direct =
        Number(variant.vialCount) ||
        Number(packButton?.dataset.vialCount) ||
        0;

      if (direct > 0) return direct;

      return parseFirstNumber(
        packButton?.dataset.packLabel,
        variant.packLabel,
        variant.variantTitle,
        packButton?.querySelector('.tvati-purchase__pack-title')?.textContent
      );
    };

    const getSellingPlanId = () => {
      if (isWholesaleCustomer) return '';

      const hiddenPlan = purchase.querySelector('input[name="selling_plan"]');
      if (hiddenPlan?.value) return String(hiddenPlan.value);

      const activeSubscription = purchase.querySelector(
        '.sls-option-container.sls-active input[data-type="subscription"]'
      );

      if (!activeSubscription) return '';

      const activeOption = activeSubscription.closest('.sls-option-container');
      const select = activeOption?.querySelector('select[name="subs_interval"]');

      return select?.value ? String(select.value) : '';
    };

    const getEffectivePrice = (variantId, packButton = null) => {
      const variant = variantData[String(variantId)] || null;
      if (!variant) return null;

      const planId = getSellingPlanId();
      const plan = planId ? variant.sellingPlans?.[String(planId)] : null;

      return {
        basePrice: Number(variant.price) || 0,
        baseFormatted: variant.priceFormatted || '',
        price: Number(plan?.price ?? variant.price) || 0,
        formatted: plan?.priceFormatted || variant.priceFormatted || '',
        planId: plan ? String(planId) : '',
        vialCount: resolveVialCount(variantId, packButton)
      };
    };

    /*
     * "FROM" daily cost should represent the lowest price actually available
     * for the selected pack, not just the currently selected purchase mode.
     *
     * Shopify's selling_plan_allocations already contain the real
     * market/currency-aware subscription price, so use the cheapest allocation
     * when subscriptions exist. If there are no selling plans, fall back to
     * the normal one-time variant price.
     */
    const getFromPriceCents = (variantId) => {
      const variant = variantData[String(variantId)] || null;
      if (!variant) return 0;

      const prices = [];

      const oneTimePrice = Number(variant.price);
      if (Number.isFinite(oneTimePrice) && oneTimePrice > 0) {
        prices.push(oneTimePrice);
      }

      Object.values(variant.sellingPlans || {}).forEach((plan) => {
        const planPrice = Number(plan?.price);

        if (Number.isFinite(planPrice) && planPrice > 0) {
          prices.push(planPrice);
        }
      });

      return prices.length ? Math.min(...prices) : 0;
    };

    const buildDuration = (vialCount, minVialsPerWeek, maxVialsPerWeek) => {
      if (!vialCount || !minVialsPerWeek || !maxVialsPerWeek) {
        const emptyDuration = Object.create(null);
        emptyDuration.heading = '';
        emptyDuration.body = '';
        return emptyDuration;
      }

      const minRate = Math.min(minVialsPerWeek, maxVialsPerWeek);
      const maxRate = Math.max(minVialsPerWeek, maxVialsPerWeek);

      const shortestWeeks = vialCount / maxRate;
      const longestWeeks = vialCount / minRate;

      if (Math.abs(minRate - maxRate) < 0.001) {
        if (minRate >= 7) {
          const dailyRate = minRate / 7;
          const days = vialCount / dailyRate;
          const label = numberLabel(days);
          const unit = Math.abs(days - 1) < 0.001 ? 'DAY' : 'DAYS';

          return {
            heading: `UP TO ${label} ${unit} OF USE`,
            body: `up to ${label} ${unit.toLowerCase()} of use`
          };
        }

        const label = numberLabel(longestWeeks);
        const unit = Math.abs(longestWeeks - 1) < 0.001 ? 'WEEK' : 'WEEKS';

        return {
          heading: `UP TO ${label} ${unit} OF USE`,
          body: `up to ${label} ${unit.toLowerCase()} of use`
        };
      }

      const shortest = numberLabel(shortestWeeks);
      const longest = numberLabel(longestWeeks);

      return {
        heading: `APPROX. ${shortest}–${longest} WEEKS OF USE`,
        body: `approximately ${shortest}–${longest} weeks of use`
      };
    };

    const buildDosageBody = (minVialsPerWeek, maxVialsPerWeek) => {
      if (!minVialsPerWeek || !maxVialsPerWeek) return '';

      const minRate = Math.min(minVialsPerWeek, maxVialsPerWeek);
      const maxRate = Math.max(minVialsPerWeek, maxVialsPerWeek);

      if (Math.abs(minRate - maxRate) < 0.001) {
        if (Math.abs(minRate - 7) < 0.001) return '1 vial daily';

        return `${numberLabel(minRate)} ${Math.abs(minRate - 1) < 0.001 ? 'vial' : 'vials'} per week`;
      }

      return `${numberLabel(minRate)}–${numberLabel(maxRate)} vials per week`;
    };

    const buildDailyCostText = (
      priceCents,
      vialCount,
      minVialsPerWeek,
      maxVialsPerWeek
    ) => {
      if (!priceCents || !vialCount || !minVialsPerWeek || !maxVialsPerWeek) return '';

      const minRate = Math.min(minVialsPerWeek, maxVialsPerWeek);
      const maxRate = Math.max(minVialsPerWeek, maxVialsPerWeek);

      const lowPerDay =
        (priceCents * minRate) /
        (vialCount * 7) /
        100;

      const highPerDay =
        (priceCents * maxRate) /
        (vialCount * 7) /
        100;

      if (Math.abs(lowPerDay - highPerDay) < 0.005) {
        return `From just ${moneyFormatter.format(lowPerDay)} per day`;
      }

      return `From ${moneyFormatter.format(lowPerDay)}–${moneyFormatter.format(highPerDay)} per day`;
    };

    const updateUsage = () => {
      const packButton =
        packButtons.find((button) => button.dataset.variantId === String(state.variantId)) ||
        getActivePackButton();

      if (!packButton) return;

      const effective = getEffectivePrice(packButton.dataset.variantId, packButton);
      if (!effective) return;

      state.variantId = String(packButton.dataset.variantId);
      state.vialCount = effective.vialCount;

      const sizeLabel = String(state.sizeLabel || '').trim();
      const sizeRange = String(state.sizeRange || '').trim();

      if (usageHeading) {
        if (isSingleVariantProduct) {
          usageHeading.textContent =
            sizeLabel ? `${sizeLabel.toUpperCase()}:` : 'USAGE:';
        } else {
          usageHeading.textContent = [
            sizeLabel ? `${sizeLabel.toUpperCase()} PET:` : '',
            sizeRange ? `FOR PETS ${sizeRange.toUpperCase()}` : ''
          ].filter(Boolean).join(' ');
        }
      }

      const duration = buildDuration(
        effective.vialCount,
        state.minVialsPerWeek,
        state.maxVialsPerWeek
      );

      if (durationText) {
        durationText.textContent = duration.heading;
        durationText.hidden = !duration.heading;
      }

      if (usageBody) {
        if (
          effective.vialCount &&
          sizeLabel &&
          duration.body &&
          state.minVialsPerWeek &&
          state.maxVialsPerWeek
        ) {
          const dosage = buildDosageBody(
            state.minVialsPerWeek,
            state.maxVialsPerWeek
          );

          if (isSingleVariantProduct) {
            usageBody.textContent =
              `${numberLabel(effective.vialCount)} pre-measured vials provide ` +
              `${duration.body} when used at ${dosage}. ` +
              `Your routine may change once you move to maintenance.`;
          } else {
            usageBody.textContent =
              `${numberLabel(effective.vialCount)} pre-measured vials provide ` +
              `${duration.body} for a ${sizeLabel.toLowerCase()} pet when used at ${dosage}. ` +
              `Their routine may change once they move to maintenance.`;
          }
        } else {
          usageBody.textContent = isSingleVariantProduct
            ? 'See the dosage & usage guide for the recommended routine.'
            : 'Select your pet size and pack to see the expected usage.';
        }
      }

      const fromPriceCents =
        getFromPriceCents(packButton.dataset.variantId) ||
        effective.price;

      const cost = buildDailyCostText(
        fromPriceCents,
        effective.vialCount,
        state.minVialsPerWeek,
        state.maxVialsPerWeek
      );

      if (dailyCost) {
        dailyCost.textContent = cost;
        dailyCost.hidden = !cost;
      }
    };

    const setRecommendedVariant = (variantId) => {
      packButtons.forEach((button) => {
        button.classList.toggle(
          'is-recommended',
          Boolean(variantId) && button.dataset.variantId === String(variantId)
        );
      });
    };

    const applySizeState = (button, { publish = true } = {}) => {
      if (!button) return;

      state.sizeIndex = Number(button.dataset.sizeIndex) || 0;
      state.sizeLabel = button.dataset.sizeLabel || '';
      state.sizeRange = button.dataset.sizeRange || '';
      state.minVialsPerWeek = Number(button.dataset.minVialsWeek) || 0;
      state.maxVialsPerWeek =
        Number(button.dataset.maxVialsWeek) ||
        state.minVialsPerWeek;

      sizeButtons.forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      setRecommendedVariant(button.dataset.recommendedVariantId || '');

      updateUsage();

      if (publish) publishState();
    };

    const parseMoneyText = (value) => {
      if (!value) return null;

      const cleaned = String(value)
        .replace(/\s+/g, '')
        .replace(/[^\d.,-]/g, '');

      if (!cleaned) return null;

      const lastDot = cleaned.lastIndexOf('.');
      const lastComma = cleaned.lastIndexOf(',');
      let normalised = cleaned;

      if (lastComma > lastDot) {
        normalised = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        normalised = cleaned.replace(/,/g, '');
      }

      const parsed = Number.parseFloat(normalised);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const readBssResolvedPrice = () => {
      if (!wholesaleBssProbe) return null;

      const descendants = [...wholesaleBssProbe.querySelectorAll('span')]
        .map((node) => parseMoneyText(node.textContent))
        .filter((value) => value !== null);

      if (descendants.length) {
        return descendants[descendants.length - 1];
      }

      return parseMoneyText(wholesaleBssProbe.textContent);
    };

    const wholesaleState = { factor: null };

    const resolveWholesaleFactor = () => {
      if (!isWholesaleCustomer || !wholesaleBssProbe) return false;

      const baseRetailCents = Number(wholesaleBssProbe.dataset.bssBaseRetailCents);
      if (!Number.isFinite(baseRetailCents) || baseRetailCents <= 0) return false;

      const bssPrice = readBssResolvedPrice();
      if (bssPrice === null) return false;

      const bssProcessed =
        wholesaleBssProbe.hasAttribute('bss-b2b-product-active') ||
        wholesaleBssProbe.querySelectorAll('span').length > 0;

      if (!bssProcessed) return false;

      const factor = Math.round(bssPrice * 100) / baseRetailCents;
      if (!Number.isFinite(factor) || factor <= 0 || factor > 2) return false;

      wholesaleState.factor = factor;
      return true;
    };

    const updateWholesalePrice = (variantId) => {
      if (!isWholesaleCustomer) return;

      const variant = variantData[String(variantId || '')];
      const retailCents = Number(variant?.price);

      if (!Number.isFinite(retailCents)) return;

      const retailFormatted = variant?.priceFormatted || moneyFormatter.format(retailCents / 100);
      const factor =
        Number.isFinite(wholesaleState.factor) && wholesaleState.factor > 0
          ? wholesaleState.factor
          : 1;

      const wholesaleCents = Math.round(retailCents * factor);
      const wholesaleFormatted = moneyFormatter.format(wholesaleCents / 100);

      [wholesaleRetailPrice, stickyWholesaleRetailPrice].forEach((node) => {
        if (!node) return;
        node.textContent = retailFormatted;
        node.hidden = wholesaleCents === retailCents;
      });

      [wholesaleResolvedPrice, stickyWholesaleResolvedPrice].forEach((node) => {
        if (!node) return;
        node.textContent = wholesaleFormatted;
      });
    };

    const updateCommercialState = () => {
      const packButton =
        packButtons.find((button) => button.dataset.variantId === String(state.variantId)) ||
        getActivePackButton();

      const activeVariantId = String(
        packButton?.dataset.variantId ||
        state.variantId ||
        purchase.dataset.initialVariantId ||
        ''
      );

      if (!activeVariantId) return;

      const effective = getEffectivePrice(activeVariantId, packButton);
      if (!effective) return;

      state.variantId = activeVariantId;
      state.vialCount = effective.vialCount;
      state.sellingPlanId = effective.planId || '';
      state.purchaseMode = effective.planId ? 'subscription' : 'one-time';

      purchase.classList.toggle(
        'is-subscription',
        state.purchaseMode === 'subscription'
      );

      if (isWholesaleCustomer) {
        updateWholesalePrice(activeVariantId);
      } else if (selectedPrice) {
        selectedPrice.textContent =
          effective.formatted ||
          packButton.dataset.price ||
          '';
      }

      if (savingText) {
        if (
          effective.planId &&
          effective.basePrice > 0 &&
          effective.price < effective.basePrice
        ) {
          const savingPercent =
            ((effective.basePrice - effective.price) / effective.basePrice) * 100;

          savingText.textContent =
            `SAVING ${percentLabel(savingPercent)}% WITH SUBSCRIPTION`;

          savingText.hidden = false;
        } else {
          savingText.textContent = '';
          savingText.hidden = true;
        }
      }

      updateUsage();
      publishState();
    };

    const updatePackDisplay = (button) => {
      if (!button) return;

      state.variantId = String(button.dataset.variantId || '');

      packButtons.forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (selectedTitle && button.dataset.displayTitle) {
        selectedTitle.textContent = button.dataset.displayTitle;
      }

      updateCommercialState();
    };

    const selectVariant = (variantId, sourceButton = null) => {
      if (!variantId) return;

      const packButton =
        sourceButton ||
        packButtons.find((button) => button.dataset.variantId === String(variantId));

      if (packButton) {
        state.variantId = String(variantId);
        updatePackDisplay(packButton);
      }

      publishState();

      const nativeInput = getNativeVariantInput(String(variantId));

      if (nativeInput && !nativeInput.checked) {
        nativeInput.click();
      }
    };

    /*
     * Initial pet-size state
     * ----------------------
     * 1. An explicit Get Started answer wins. This preserves Large even when
     *    Large and Medium both recommend the same 30-pack.
     * 2. On a normal direct variant URL, infer the first size recommending that
     *    pack. With Small / Medium / Large ordering, a bare 30-pack URL lands
     *    on Medium.
     * 3. Fall back to the normal first size.
     */
    const initialVariantId = String(purchase.dataset.initialVariantId || '');

    const getStartedSizeButton =
      getStartedHandoff
        ? getSizeButtonByIndex(getStartedHandoff.sizeIndex)
        : null;

    let initialSizeButton =
      getStartedSizeButton ||
      sizeButtons.find(
        (button) =>
          initialVariantId &&
          String(button.dataset.recommendedVariantId || '') === initialVariantId
      ) ||
      getSizeButtonByIndex(state.sizeIndex) ||
      sizeButtons[0] ||
      null;

    if (initialSizeButton) {
      applySizeState(initialSizeButton, { publish: false });
    }

    const initialPackButton =
      packButtons.find(
        (button) =>
          button.dataset.variantId === initialVariantId
      ) ||
      getActivePackButton();

    if (initialPackButton) {
      state.variantId = String(initialPackButton.dataset.variantId);
      updatePackDisplay(initialPackButton);
    } else {
      updateUsage();
      publishState();
    }

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        applySizeState(button);

        const recommendedVariantId = button.dataset.recommendedVariantId || '';

        if (recommendedVariantId) {
          selectVariant(recommendedVariantId);
        } else {
          updateCommercialState();
        }
      });
    });

    packButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectVariant(button.dataset.variantId, button);
      });
    });

    dosageTrigger?.addEventListener('click', () => {
      if (!tabs) return;

      const dosageButton = [...tabs.querySelectorAll('[data-tvati-tab-button]')].find(
        (button) =>
          button.textContent.trim().toLowerCase().includes('dosage')
      );

      if (!dosageButton) return;

      activateTab(dosageButton);
      tabs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    const getNativeAddToCartButton = () => {
      const buttons = [...purchase.querySelectorAll('.add-to-cart-button')];

      if (!buttons.length) return null;

      return (
        buttons.find((button) => {
          const rect = button.getBoundingClientRect();
          const style = window.getComputedStyle(button);

          return (
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            rect.width > 0 &&
            rect.height > 0
          );
        }) ||
        buttons[0]
      );
    };

    const getNativeAddToCartLabel = (button) => {
      if (!button) return 'ADD TO BAG';

      if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
        const raw = button.textContent?.trim() || '';
        if (/sold\s*out/i.test(raw)) return 'SOLD OUT';
        if (/unavailable/i.test(raw)) return 'UNAVAILABLE';
      }

      return getSellingPlanId() ? 'START SUBSCRIPTION' : 'ADD TO BAG';
    };

    const syncStickyAddToCart = () => {
      if (!stickyAtc || !stickyAtcButton) return;

      const nativeButton = getNativeAddToCartButton();

      if (!nativeButton) {
        stickyAtc.classList.remove('is-visible');
        stickyAtc.setAttribute('aria-hidden', 'true');
        return;
      }

      const disabled =
        nativeButton.disabled ||
        nativeButton.getAttribute('aria-disabled') === 'true';

      stickyAtcButton.disabled = disabled;
      stickyAtcButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');

      const packButton =
        packButtons.find((button) => button.dataset.variantId === String(state.variantId)) ||
        getActivePackButton();

      const stickyVariantId = String(
        packButton?.dataset.variantId ||
        state.variantId ||
        purchase.dataset.initialVariantId ||
        ''
      );

      const effective = stickyVariantId
        ? getEffectivePrice(stickyVariantId, packButton)
        : null;

      const isSubscription = Boolean(effective?.planId || getSellingPlanId());

      if (stickyAtcPack && packButton) {
        stickyAtcPack.textContent =
          packButton.dataset.packLabel ||
          variantData[String(packButton.dataset.variantId)]?.packLabel ||
          '';
      }

      if (stickyAtcPrice && effective) {
        if (isWholesaleCustomer) {
          updateWholesalePrice(stickyVariantId);
        } else {
          stickyAtcPrice.textContent =
            effective.formatted ||
            packButton?.dataset.price ||
            '';
        }
      }

      if (stickyAtcMode) {
        let modeLabel = isSubscription
          ? 'SUBSCRIBE & SAVE'
          : 'ONE-TIME PURCHASE';

        if (
          isSubscription &&
          effective &&
          effective.basePrice > 0 &&
          effective.price < effective.basePrice
        ) {
          const savingPercent =
            ((effective.basePrice - effective.price) / effective.basePrice) * 100;

          modeLabel = `SUBSCRIBE & SAVE ${percentLabel(savingPercent)}%`;
        }

        stickyAtcMode.textContent = modeLabel;
      }

      if (stickyAtcLabel) {
        stickyAtcLabel.textContent = getNativeAddToCartLabel(nativeButton);
      }

      stickyAtcButton.setAttribute(
        'aria-label',
        getNativeAddToCartLabel(nativeButton)
      );
    };

    const updateStickyAddToCartVisibility = () => {
      if (!stickyAtc || !stickyAtcButton) return;

      const nativeButton = getNativeAddToCartButton();

      if (!nativeButton) {
        stickyAtc.classList.remove('is-visible');
        stickyAtc.setAttribute('aria-hidden', 'true');
        return;
      }

      const nativeButtonRect = nativeButton.getBoundingClientRect();

      /*
       * Desktop:
       * show once the real CTA has passed behind the header area.
       *
       * Mobile:
       * keep the original behaviour and wait until the real CTA has fully
       * passed above the viewport.
       *
       * Checking the BOTTOM edge prevents the sticky CTA appearing simply
       * because the real CTA starts below the fold.
       */
      const passedThreshold =
        window.matchMedia('(min-width: 750px)').matches
          ? 110
          : 0;

      const hasPassedNativeButton =
        nativeButtonRect.bottom <= passedThreshold;

      const cartDrawerOpen = Boolean(
        document.querySelector('theme-drawer[open] cart-drawer-component')
      );

      /*
       * Stop the sticky CTA before it can overlap the footer.
       * As soon as the footer enters the viewport, hide the sticky bar.
       */
      const footer = document.querySelector('footer');
      const footerRect = footer?.getBoundingClientRect();
      const footerReached =
        Boolean(footerRect) &&
        footerRect.top <= window.innerHeight;

      const shouldShow =
        hasPassedNativeButton &&
        !cartDrawerOpen &&
        !footerReached;

      stickyAtc.classList.toggle('is-visible', shouldShow);
      stickyAtc.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    let stickyAtcRaf = null;

    const scheduleStickyAddToCartUpdate = () => {
      if (stickyAtcRaf !== null) return;

      stickyAtcRaf = requestAnimationFrame(() => {
        stickyAtcRaf = null;
        syncStickyAddToCart();
        updateStickyAddToCartVisibility();
      });
    };

    stickyAtcButton?.addEventListener('click', () => {
      const nativeButton = getNativeAddToCartButton();

      if (
        !nativeButton ||
        nativeButton.disabled ||
        nativeButton.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      /*
       * Proxy the REAL Shopify/Seal Add to Cart button.
       * This keeps variant, quantity and selling_plan handling completely
       * owned by the native product form.
       */
      nativeButton.click();
    });

    /*
     * Sticky trigger watcher
     * ----------------------
     * Some Shopify/theme layouts scroll an inner container rather than the
     * window itself. A window-only scroll listener can therefore miss the
     * movement completely. Listen in capture phase on document as well, and
     * use IntersectionObserver as a second independent signal.
     */
    window.addEventListener('scroll', scheduleStickyAddToCartUpdate, {
      passive: true
    });

    document.addEventListener('scroll', scheduleStickyAddToCartUpdate, {
      passive: true,
      capture: true
    });

    window.addEventListener('resize', scheduleStickyAddToCartUpdate, {
      passive: true
    });

    window.addEventListener('orientationchange', scheduleStickyAddToCartUpdate, {
      passive: true
    });

    let stickyTriggerObserver = null;
    let stickyObservedButton = null;

    const refreshStickyTriggerObserver = () => {
      const nativeButton = getNativeAddToCartButton();

      if (!nativeButton) {
        stickyTriggerObserver?.disconnect();
        stickyTriggerObserver = null;
        stickyObservedButton = null;
        scheduleStickyAddToCartUpdate();
        return;
      }

      if (nativeButton === stickyObservedButton && stickyTriggerObserver) {
        return;
      }

      stickyTriggerObserver?.disconnect();

      stickyObservedButton = nativeButton;

      stickyTriggerObserver = new IntersectionObserver(
        () => {
          scheduleStickyAddToCartUpdate();
        },
        {
          root: null,
          threshold: [0, 0.01, 1]
        }
      );

      stickyTriggerObserver.observe(nativeButton);
      scheduleStickyAddToCartUpdate();
    };

    refreshStickyTriggerObserver();

    requestAnimationFrame(scheduleStickyAddToCartUpdate);
    window.setTimeout(scheduleStickyAddToCartUpdate, 120);
    window.setTimeout(scheduleStickyAddToCartUpdate, 500);

    const updateAddToBagText = () => {
      const button = purchase.querySelector('.add-to-cart-button');
      if (!button) return;

      if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const isSubscription = Boolean(getSellingPlanId());
      const label = isSubscription
        ? 'START SUBSCRIPTION'
        : 'ADD TO BAG';

      [...button.childNodes].forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        if (!node.textContent.trim()) return;

        node.textContent = ` ${label} `;
      });

      button.setAttribute('aria-label', label);
    };

    const syncSealState = () => {
      updateCommercialState();
      updateAddToBagText();
      syncStickyAddToCart();
      updateStickyAddToCartVisibility();
    };

    purchase.addEventListener('change', (event) => {
      if (!event.target.closest('.sealsubs-container')) return;

      requestAnimationFrame(syncSealState);
      window.setTimeout(syncSealState, 60);
      window.setTimeout(syncSealState, 180);
    });

    purchase.addEventListener('click', (event) => {
      if (!event.target.closest('.sls-option-container')) return;

      requestAnimationFrame(syncSealState);
      window.setTimeout(syncSealState, 60);
      window.setTimeout(syncSealState, 180);
    });

    if (isWholesaleCustomer && wholesaleBssProbe) {
      const refreshWholesalePricing = () => {
        if (resolveWholesaleFactor()) {
          updateWholesalePrice(state.variantId || purchase.dataset.initialVariantId);
        }
      };

      refreshWholesalePricing();

      const wholesalePriceObserver = new MutationObserver(refreshWholesalePricing);
      wholesalePriceObserver.observe(wholesaleBssProbe, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['bss-b2b-product-active', 'style']
      });

      document.addEventListener('bss_b2b_doneCheckCp', () => {
        window.requestAnimationFrame(refreshWholesalePricing);
      });
    }

    updateCommercialState();
    updateAddToBagText();
    syncStickyAddToCart();
    updateStickyAddToCartVisibility();

    const purchaseObserver = new MutationObserver(() => {
      syncSealState();
      refreshStickyTriggerObserver();
    });

    if (nativePurchase) {
      purchaseObserver.observe(nativePurchase, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'value', 'checked']
      });
    }

    section.addEventListener('shopify:product:select', (event) => {
      const synchronousVariantId = event.detail?.variantId;

      if (synchronousVariantId) {
        state.variantId = String(synchronousVariantId);

        const button = packButtons.find(
          (candidate) =>
            candidate.dataset.variantId === String(synchronousVariantId)
        );

        if (button) updatePackDisplay(button);
        publishState();
      }

      event.promise
        ?.then(({ detail }) => {
          const variantId = detail?.resource?.id;
          if (!variantId) return;

          state.variantId = String(variantId);

          const button = packButtons.find(
            (candidate) =>
              candidate.dataset.variantId === String(variantId)
          );

          if (button) updatePackDisplay(button);

          publishState();

          window.setTimeout(syncSealState, 0);
          window.setTimeout(syncSealState, 80);
          window.setTimeout(syncSealState, 180);
        })
        .catch(() => {});
    });
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-tvati-product-main]')) {
      initProductMain(root);
    }

    root.querySelectorAll?.('[data-tvati-product-main]').forEach(initProductMain);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
